import ApiClient from '@/ApiClient';
import { keepPreviousData, queryOptions } from '@tanstack/vue-query';

// Paginated shifts list. `params` is a ref of the query object (offset/count/dates/field[op]=value) — the query
// refetches whenever it changes. `useV2` (a ref) selects the operator-filter endpoint. Disabled until params is set.
export const getShiftsPage = (params, useV2) =>
  queryOptions({
    queryKey: ['shifts', useV2, params],
    enabled: () => params.value != null,
    // ApiError carries no status, so a rejected filter can't be told from a blip; don't multiply the noise.
    retry: false,
    // Hold the last page while the next loads: without it data (and so the total) drops to undefined/0 on every key
    // change, b-pagination clamps to page 1, and the list bounces straight back to the first page.
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const fetchPage = useV2.value ? ApiClient.getPaginatedShiftsV2 : ApiClient.getPaginatedShifts;
      const { data } = await fetchPage(params.value);
      return data;
    },
  });
